import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import history from '../../../route/history'
import { userinfoActions, alertActions, authActions } from '../../../store/actions'
import Zip from '../../../module/zip'
import { valid } from '../../../hook/valid'

import Input from '../../../module/input'
import moment from 'moment'
import Alert from '../../../module/alert/Alert'
import InactiveBox from './InactiveBox'
import Clipboard from 'react-clipboard.js'
import { uriConstants } from '../../../store/constants'
import * as common from '../../../assets/js/common.js'

const ChangeLogin = (props) => {
  const [state, setState] = useState({
    isView: false,
    data: null,
  })

  useEffect(() => {
    props.load()
  }, [])

  useEffect(() => {
    console.log('uri 1확인~', uriConstants.API_URI)
    console.log('uri 2확인~', uriConstants.HOME_URI)
    props.snsLoad()
  }, [])

  useEffect(() => {
    setState({
      ...state,
      ...props.userInfo,
    })
  }, [props.userInfo])

  useEffect(() => {
    props.callDgtOnePass()
  }, [])

  useEffect(() => {
    setState({ ...state, data: props.auth })
  }, [props.auth])

  const generateRandomString = (num) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let result1 = ' '
    const charactersLength = characters.length
    for (let i = 0; i < num; i++) {
      result1 += characters.charAt(Math.floor(Math.random() * charactersLength))
    }

    return result1
  }

  const onSelecte = (snsType) => {
    //카카오 로그인 정보
    const KAKAO_CLIENT_ID = '49f20bc8980432102cb921e76b919790'
    const KAKAO_REDIRECT_URI = uriConstants.API_URI + '/oauth/callback/kakao'
    const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_CLIENT_ID}&redirect_uri=${KAKAO_REDIRECT_URI}&response_type=code`

    //네이버 로그인 정보
    const NAVER_STATE = generateRandomString(5)
    const NAVER_CLIENT_ID = '2vQXZFhbDAVORqK4WCEF'
    const NAVER_REDIRECT_URI = uriConstants.API_URI + '/oauth/callback/naver'
    const NAVER_AUTH_URL = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&redirect_uri=${NAVER_REDIRECT_URI}&state=${NAVER_STATE};`

    //디지털원패스
    const DGT_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_CLIENT_ID}&redirect_uri=${KAKAO_REDIRECT_URI}&response_type=code`

    if (common.getDeviceType() === 'MobileApp') {
      if (snsType === 'naver') {
        var result = window.M.execute('exWNNaverAuthIsLogin')
        //window.M.pop.alert(', result : ' + JSON.stringify(result));
        if (result === 'OK') {
          window.M.execute('exWNNaverAuthLogout')
          window.M.execute(
            'exWNNaverAuthLogin',
            window.M.response
              .on(function (status, result) {
                console.log(status)
                console.log(result.data.id)

                // window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));

                if (status === 'SUCCESS') {
                  props.addNaverLoginMobile(result.data.id)
                }
              })
              .toString(),
          )
        } else if (result === 'NEED_LOGIN' || result === 'NEED_REFRESH_TOKEN') {
          window.M.execute(
            'exWNNaverAuthLogin',
            window.M.response
              .on(function (status, result) {
                console.log(status)
                console.log(result.data.id)

                // window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));

                if (status === 'SUCCESS') {
                  props.addNaverLoginMobile(result.data.id)
                } else {
                  window.M.execute('exWNNaverAuthLogout')
                }
              })
              .toString(),
          )
        }
      } else if (snsType === 'kakao') {
        window.M.execute(
          'exWNKakaoAuthIsLogin',
          window.M.response
            .on(function (status, result) {
              console.log(status)
              console.log(result)
              // 'OK':로그인 된 상태, 'NEED_LOGIN':로그인 안 된 상태
              //  window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
              if (status === 'OK') {
                window.M.execute(
                  'exWNKakaoAuthLogout',
                  window.M.response
                    .on(function (status, result) {
                      console.log(status)
                      console.log(result)
                      //  window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
                      if (status === 'SUCCESS') {
                        window.M.execute(
                          'exWNKakaoAuthLogin',
                          window.M.response
                            .on(function (status, result) {
                              console.log(status)
                              console.log(result)
                              console.log(result.data.id)
                              //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
                              //window.M.pop.alert(status +','+ result.id);
                              if (status === 'SUCCESS') {
                                //props.addKakaoLoginMobile(result.id)
                                props.addKakaoLoginMobile(result.data.id)
                              }
                            })
                            .toString(),
                        )
                      }
                    })
                    .toString(),
                )
              } else if (status === 'NEED_LOGIN') {
                window.M.execute(
                  'exWNKakaoAuthLogin',
                  window.M.response
                    .on(function (status, result) {
                      console.log(status)
                      console.log(result)
                      // window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
                      //window.M.pop.alert(status +','+ result.id);
                      if (status === 'SUCCESS') {
                        ///props.addKakaoLoginMobile(result.id)
                        props.addKakaoLoginMobile(result.data.id)
                      }
                    })
                    .toString(),
                )
              }
            })
            .toString(),
        )

        /* window.M.execute('exWNKakaoAuthLogin',
          window.M.response.on( function( status, result ) {
              console.log(status);
              console.log(result);
              window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
              //window.M.pop.alert(status +','+ result.id);
              if(status === 'SUCCESS'){
                props.addKakaoLoginMobile(result.id)
              }else{
                window.M.execute('exWNKakaoAuthLogout',
                window.M.response.on( function( status, result ) {
                        console.log(status);
                        console.log(result);
                        window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
                    }).toString()
                );
              }
          }).toString()
      ); */
      }
    } else {
      var url = ''
      if (snsType === 'naver') {
        url = NAVER_AUTH_URL
      } else if (snsType === 'kakao') {
        url = KAKAO_AUTH_URL
      } else if (snsType === 'dgt') {
        url = DGT_AUTH_URL
      }
      window.location.href = url
    }
  }
  const onDelete = (snsType) => {
    props.confirm({
      title: '확인',
      message: '연동해제를 하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          if (common.getDeviceType() === 'MobileApp') {
            if (snsType === 'naver') {
              window.M.execute(
                'exWNNaverAuthDisConnect',
                window.M.response
                  .on(function (status, result) {
                    console.log(status)
                    console.log(result)
                    props.snsLoginDisconnect(snsType)
                    // window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
                  })
                  .toString(),
              )
            } else if (snsType === 'kakao') {
              window.M.execute(
                'exWNKakaoAuthDisConnect',
                window.M.response
                  .on(function (status, result) {
                    console.log(status)
                    console.log(result)
                    props.snsLoginDisconnect(snsType)
                    // window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
                  })
                  .toString(),
              )
            }
          } else {
            props.snsLoginDisconnect(snsType)
          }
        },
      },
    })
  }

  /* useEffect(() => {
    window.Kakao.init("2b1ec7d275dd096306ffc1c55a5c8e1c");
  }, []);

  const shareKakao = () => {
    window.Kakao.Link.sendDefault({
      objectType: "feed",
        content: {
          title: "11111",
          description: "내용!",
          imageUrl: "112222",
          link: {
            mobileWebUrl: "모바일 url!",
            androidExecParams: "test",
          },
        },
        buttons: [
          {
            title: "웹으로 이동",
            link: {
              mobileWebUrl: "공유할 url!",
            },
          },
        ],
    });
  } */
  return (
    <React.Fragment>
      {/* container */}
      <div id="container">
        {/* contents */}
        <div id="contents">
          {/* <Alert /> */}
          <div className="content-header">
            <a
              href="#"
              className="page-prev"
              onClick={(e) => {
                e.preventDefault()
                window.history.back()
              }}
            >
              뒤로이동
            </a>
            {/* <!-- mobile --> */}
            <h2>로그인 설정</h2>
            <div className="breadcrumb">
              <span>Home</span>
              <span>마이페이지</span>
              <em>로그인 설정</em>
            </div>
          </div>
          <div className="cert-box">
            <dl>
              <dt>간편 로그인 설정</dt>
              <dd>
                간편 로그인을 설정하시면, 연동된 계정으로 쉽고 빠른 로그인이 가능합니다.
                {/* <button onClick={shareKakao}>카카오톡 공유하기</button> */}
              </dd>
            </dl>
          </div>
          <div className="cert-gray-box mt20">
            <ul className="login-setup">
              {props.snsInfoList.length > 0
                ? props.snsInfoList?.map((info, index) => (
                   // 디지털 원패스 숨김 처리 (수정)
                   info.snsType !== 'onepass' ? (
                    <li key={index} className={info.snsType}>
                      <div className="box">
                        <i className="ico" />
                        <p>
                          {info.snsName}
                          {info?.regDt ? <span>연동 일자 : {moment(info.regDt).format('YYYY.MM.DD')}</span> : ''}
                        </p>
                      </div>
                      
                      {info?.regDt ? (
                        info.snsType === 'onepass' ? (
                          <form name="oform" action={state.data?.action} method="POST">
                            <input type="hidden" name={state.data?.inputName} value={state.data?.inputValue} />
                            <input
                              type="hidden"
                              name="returnUrl"
                              value={uriConstants.API_URI + uriConstants.ADD_ONEPASS_CHECK + '?stateType=disConnect'}
                            />
                            {/* <input type="hidden" name="stateType" value="disConnect" /> */}
                            <button type="submit" className="btn-secondary lg">
                              연동해제
                            </button>
                          </form>
                        ) : (
                          <a href="#" onClick={() => onDelete(info.snsType)} className="btn-secondary lg">
                            연동해제
                          </a>
                        )
                      ) : info.snsType === 'onepass' ? (
                        <a className="btn-secondary lg">로그인시 연동</a>
                      ) : (
                        <a href="#" onClick={() => onSelecte(info.snsType)} className="btn-primary lg">
                          연동하기
                        </a>
                      )}
                    </li>
                   ) : (
                    <div></div>
                   )
                  ))
                : ''}
            </ul>
          </div>
          {/* <ul className="ulist1 mt10">
              <li>디지털원패스는 연동해제가 불가능합니다.</li>
              <li>
                디지털원패스 이용문의 : 1533-3713 (평일 9~18시 / 공휴일제외)
              </li>
            </ul> */}
        </div>
        {/* //contents */}
      </div>
      {/* //container */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    userInfo: state.userinfo?.data,
    snsInfoList: state.userinfo?.snsInfoList,
    auth: state.auth.data,
  }
}

const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  confirm: alertActions.confirm,
  load: userinfoActions.load,
  snsLoad: userinfoActions.snsLoad,
  snsLoginDisconnect: userinfoActions.snsLoginDisconnect,
  addKakaoLoginMobile: userinfoActions.addKakaoLoginMobile,
  addNaverLoginMobile: userinfoActions.addNaverLoginMobile,
  callDgtOnePass: authActions.callDgtOnePass,
  // getUserInfo: authActions.getUserInfo,
  // userInfoListData: authActions.userInfoListData,
}

export default connect(mapStateToProps, actionCreators)(ChangeLogin)
